// Angular
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// Rxjs
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

// Service
import { TokenStorageService } from '../../../app/state/core/services/token-storage/token-storage.service';
import { GlobalStoreService } from '../../../app/state/global/global-store.service';
import { AuthStoreService } from '../../../app/state/modules/auth/auth-store.service';

// Constant
import { ROUTE_CONSTANTS } from '../../../app/constants/route';

/**
 * This component used to navigate to login if the request is unauthorized
 *
 * @author Vikas thakkar <vikasthakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 29/04/2020 (Vikas thakkar <vikasthakkar@saeculumsolutions.com>) AuthInterceptor created
 */
@Injectable({
  providedIn: 'root',
})

export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router,
    private tokenStorageService: TokenStorageService,
    private authStoreService: AuthStoreService,
  ) {
  }

  /**
	 * Intercepts the response and navigate to login if the accesstoken is not valid
	 * @param {HttpRequest<any>} request
	 * @param {HttpHandler} next
	 * @returns {Observable<HttpEvent<any>>}
	 */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error, caught) => {
        this.handleAuthError(error);
        return of(error);
      }) as any,
      finalize(() => true),
    );
  }


  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // User-approved A8-parity exemption (2026-06-11): the dev billing service rejects
    // SA tokens on sa/business-billing/lookup* with 401 ("User Token Malformed" —
    // pre-existing backend defect). The Angular 8 app demonstrably does NOT log the
    // user out when this endpoint 401s; the migrated app must behave the same.
    // Scope is exactly this endpoint — every other 401 still logs out as before.
    const isBillingLookup401 = err && err.url && err.url.includes('business-billing/lookup');
    if (err.status === 401 && !isBillingLookup401) {
      this.tokenStorageService.clear();
      this.authStoreService.dispatchClearReducer({});
      this.router.navigate([ROUTE_CONSTANTS.CONTAINER.AUTH, ROUTE_CONSTANTS.AUTH.LOGIN]);
    }
    throw err;
  }
}

